export enum PhoneSettingsType{
    IMPORTED = 'IMPORTED',
    BOUGHT = 'BOUGHT'
}